import {useState} from "react";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {Component, ComponentStatus} from "@/lib/types/statuspages.ts";
import {StatusPageComponentGroupUpdateModal} from "@/pages/statuspages/tabs/components/componentGroupModal/StatusPageComponentGroupUpdateModal.tsx";
import {StatusPageComponentUpdateModal} from "@/pages/statuspages/tabs/components/componentModal/StatusPageComponentUpdateModal.tsx";
import {deleteStatusPageComponent} from "@/pages/statuspages/utils/quickActions.ts";

interface StatusPageComponentsRowActionsProps {
  component: Component;
  statusPageID: number;
  components: Component[];
  componentStatuses: ComponentStatus[];
}

export const StatusPageComponentsRowActions = ({
  component,
  statusPageID,
  components,
  componentStatuses,
}: StatusPageComponentsRowActionsProps) => {
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);

  return (
    <>
      <QuickActionsBar
        id={`component-actions-${component.id}`}
        actions={[
          <DropdownAction
            id={`component-actions-dropdown-${component.id}`}
            items={[
              <DropdownActionItem text="Edit" onClick={() => setShowEdit(true)} />,
              <DropdownActionItem text="Delete" onClick={() => setShowDelete(true)} />,
            ]}
          />,
        ]}
      />

      {component.is_group ? (
        <StatusPageComponentGroupUpdateModal
          show={showEdit}
          setShow={setShowEdit}
          statusPageID={statusPageID}
          component={component}
          defaultComponents={components}
        />
      ) : (
        <StatusPageComponentUpdateModal
          show={showEdit}
          setShow={setShowEdit}
          statusPageID={statusPageID}
          title="Edit Component"
          submitBtnText={"Save Changes"}
          component={component}
          components={components}
          componentStatuses={componentStatuses}
        />
      )}

      <DeleteActionDialog
        show={showDelete}
        title={`Delete Component${component.is_group ? " Group" : ""}`}
        onConfirm={async () => {
          await deleteStatusPageComponent(statusPageID, component.id);
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete <code>{component.name}</code> ? This will affect the Components listed in any
        related Incident.
      </DeleteActionDialog>
    </>
  );
};
